export default {
  components: {},
  props: {
    comData: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  computed: {
    activityId() {
      return this.comData.activityId
    },
    spikeGoods() {
      if (!this.comData.spikeSections || !this.comData.spikeSections.length)  return []
      // 排除活动已经结束的
      let startSpike = this.comData.spikeSections.filter((item, index) => {
        return new Date(item.endTime).getTime() > new Date().getTime()
      })
      if (!startSpike.length) return []
      startSpike.forEach((item,index) => {
        for(let i=0; i < item.spikeGoods.length; i++) {
          // 排除已经下架的活动
          if (item.spikeGoods[i].status == 1) {
            item.spikeGoods.splice(i, 1)
            i--
          }
        }
      });
      this.spikeSections = startSpike
      if (startSpike.length) {
        for(let i=0; i < startSpike.length; i++) {
          if (startSpike[i].spikeGoods.length) {
            this.boolPrePay = startSpike[i].boolPrePay || false
            return startSpike[i].spikeGoods
          }
        }
      }
    },
    // 组件创建方式
    isNewCreationMode() {
      return this.$route.query.creationMode == 'new'
    }
  },
  data() {
    return {
      spikeRolling: [],
      spikeSections: [],
      boolPrePay: false,
    }
  },
  methods:{
    jumpSpikeList() {
      if (this.isNewCreationMode) return
      this.$router.push({
        path: '/spike-list',
        query: {spikeList: JSON.stringify(this.spikeSections),activityId: this.activityId}
      })
    },
    getSeckillRolling() {
      this.$api.spike.getSeckillRolling(this.activityId).then(res => {
        if (res.success) {
          this.spikeRolling = res.data
        }
      })
    }
  },
  mounted() {
    if (this.activityId) {
      this.getSeckillRolling()
    }
  }
}